<section class="m-section">
  <div class="container">
    @if (post && !loader) {
    <div class="content">
      <div class="button-back">
        <a (click)="goTo('nav')" routerLink="/blog" class="btn-back" aria-label="Volver al listado del blog">
          <i class="pi pi-arrow-left"></i>
          <span>Volver al blog</span>
        </a>
      </div>

      <div class="content-blog">
        <div class="title">
          <h1> {{ post.blogTitle }} </h1>
          <p>{{ post.date }}</p>
        </div>
        <div class="image">
          <img [src]="getImageSrc(post)" alt="Imagen del blog">
        </div>
        <div class="text-blog" [innerHTML]="this.post.blogContent">
        </div>
        @if (post.cta) {
        <div style="max-width: 300px;">
          <app-button [text]="post.cta" backgroundColor="#173D54" textColor="#FFFFFF" (clicked)="ctaGoTo(post.ctaUrl)">
          </app-button>
        </div>
        }
      </div>

      <div class="nav-posts">
        <button type="button" class="nav-card nav-prev" (click)="prevEntry()" [attr.aria-label]="'Ir a: ' + (prevPost?.blogTitle || 'entrada anterior')">
          <span class="nav-label"><i class="pi pi-arrow-left"></i> Anterior</span>
          @if (prevPost) {
            <span class="nav-title">{{ prevPost.blogTitle }}</span>
            <span class="nav-date">{{ prevPost.date }}</span>
          }
        </button>
        <button type="button" class="nav-card nav-next" (click)="nextEntry()" [attr.aria-label]="'Ir a: ' + (nextPost?.blogTitle || 'entrada siguiente')">
          <span class="nav-label">Siguiente <i class="pi pi-arrow-right"></i></span>
          @if (nextPost) {
            <span class="nav-title">{{ nextPost.blogTitle }}</span>
            <span class="nav-date">{{ nextPost.date }}</span>
          }
        </button>
      </div>
    </div>
    } @else {
    <app-loader></app-loader>
    }
  </div>
</section>